import Markdown from "../Markdown";
import cn from "clsx";
import styles from "./styles.module.scss";

export default function BulletsMarkdown({ children, classNames = "" }) {
  return (
    <Markdown className={cn(styles.root, classNames)}>{children}</Markdown>
  );
}
